// SPDX-License-Identifier: AGPL-3.0-or-later

import {SettingsSection} from '@app/features/app/components/dialogs/shared/SettingsSection';
import {CommunicationTabContent as CommunicationTab} from '@app/features/user/components/modals/tabs/privacy_safety_tab/CommunicationTab';
import {ConnectionsTabContent as ConnectionsTab} from '@app/features/user/components/modals/tabs/privacy_safety_tab/ConnectionsTab';
import {DataDeletionTabContent as DataDeletionTab} from '@app/features/user/components/modals/tabs/privacy_safety_tab/DataDeletionTab';
import {DataExportTabContent as DataExportTab} from '@app/features/user/components/modals/tabs/privacy_safety_tab/DataExportTab';
import styles from '@app/features/user/components/modals/tabs/privacy_safety_tab/Inline.module.css';
import {MentionPreferenceTabContent as MentionPreferenceTab} from '@app/features/user/components/modals/tabs/privacy_safety_tab/MentionPreferenceTab';
import {SensitiveContentTabContent as SensitiveContentTab} from '@app/features/user/components/modals/tabs/privacy_safety_tab/SensitiveContentTab';
import {useLingui} from '@lingui/react/macro';
import {observer} from 'mobx-react-lite';
import type React from 'react';
export const PrivacySafetyInlineContent: React.FC = observer(() => {
	const {t} = useLingui();
	return (
		<div className={styles.container}>
			<SettingsSection id="connections" title={t`Connections`}>
				<ConnectionsTab />
			</SettingsSection>
			<SettingsSection id="communication" title={t`Communication`}>
				<CommunicationTab />
			</SettingsSection>
			<SettingsSection id="mention-preference" title={t`Mention Preference`}>
				<MentionPreferenceTab />
			</SettingsSection>
			<SettingsSection id="sensitive-content" title={t`Sensitive Content`}>
				<SensitiveContentTab />
			</SettingsSection>
			<SettingsSection id="data-export" title={t`Data Export`}>
				<DataExportTab />
			</SettingsSection>
			<SettingsSection id="data-deletion" title={t`Data Deletion`}>
				<DataDeletionTab />
			</SettingsSection>
		</div>
	);
});
